import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../components/ui/card";
import { AlertTriangle } from "lucide-react";
import { RouterPath } from "../../assets/dictionary/RouterPath";

export default function LinkNotValid() {
  const navigate = useNavigate();
  return (
    <div className="relative min-h-screen bg-gradient-to-b from-rose-50 via-background to-background dark:from-rose-950/40 dark:via-background dark:to-background flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Card className="glass-card border-muted shadow-2xl">
          <CardHeader className="text-center space-y-4">
            <div className="w-16 h-16 bg-yellow-100 dark:bg-yellow-900 rounded-full flex items-center justify-center mx-auto">
              <AlertTriangle className="h-8 w-8 text-yellow-600 dark:text-yellow-400" />
            </div>
            <CardTitle className="text-2xl font-bold text-high-contrast">Lien non valide</CardTitle>
            <CardDescription className="text-muted-foreground">
              Désolé, le lien que vous avez utilisé n'est pas valide ou a expiré.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-2">
            <Button className="w-full" variant="secondary" onClick={() => window.history.back()}>
              Retour à la page précédente
            </Button>
            <Button className="w-full" onClick={() => navigate(RouterPath.HOME)}>
              Aller à l'accueil
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
